import classNames from 'classnames';
import type { IntlKey } from 'locales';
import type { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

export type FieldValueListLayoutProps = {
  value?: ReactNode;
  valueClassName?: string;
  children?: ReactNode;
  fullWidthLabel?: boolean;
} & ({ translate: true; label?: IntlKey } | { translate?: false; label?: ReactNode });

export function FieldValueListLayout({
  value,
  children,
  fullWidthLabel = false,
  valueClassName,
  ...props
}: FieldValueListLayoutProps) {
  return (
    <li
      className={classNames('list-group-item border-bottom d-md-flex justify-content-md-between ps-0 pe-3', {
        'flex-wrap': fullWidthLabel,
      })}
      data-e2e="field-value-item"
    >
      {props.label && (
        <label className={classNames('text-secondary mb-0', { 'w-100': fullWidthLabel })} data-e2e="field-name">
          {props.translate ? <FormattedMessage id={props.label} /> : props.label}
        </label>
      )}
      {value && (
        <div
          className={classNames(valueClassName, { 'text-truncate': !fullWidthLabel, 'pt-1': fullWidthLabel })}
          data-e2e="field-value"
        >
          {value}
        </div>
      )}
      {children}
    </li>
  );
}
